import { useState } from "react";

export const useCampaignDetailsForm = () => {
  const [selectedSegmentId, setSelectedSegmentId] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSelectedSegmentId(null);
  };

  const handleOpen = (id = null) => {
    setSelectedSegmentId(id);
    setOpen(true);
  };

  const getSelectedSegment = (segments) =>
    segments?.find((segment) => segment.id === selectedSegmentId);

  return {
    open,
    handleClose,
    handleOpen,
    selectedSegmentId,
    getSelectedSegment,
  };
};
